import { render, staticRenderFns } from "./Services1.vue?vue&type=template&id=5de5dac9"
import script from "./Services1.vue?vue&type=script&lang=js"
export * from "./Services1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_1d815c3a82e414dc02ba46af5dbd33b7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports